// ##### 25-03-26 Komarov
import {
  GET_LOADED_PAGE_ERR,
  GET_LOADED_PAGE_REQ,
  GET_LOADED_PAGE_RES,
  GET_PAGES_ERR,
  GET_PAGES_REQ,
  GET_PAGES_RES,
  SET_PAGES_REDUX,
} from '../constants';
// ##### 25-01-09 Komarov
import { getUrl } from '../../helpers/crypto';
// ##### 25-02-26 Komarov
import { uniLog } from '../../../server/helpers/uniLog';
// ##### 25-03-28 Komarov
import { getSavingDataClient } from '../../helpers/saveData';
import { getPagesToRedux } from '../../helpers/messages';

// ##### 24-03-21 Komarov
export const getPages = lang => async dispatch => {
  dispatch({ type: GET_PAGES_REQ });
  // console.log('REDUX_LOCALE:',lang)
  // ##### Komarov 2025-08-05
  // ##### Komarov 2025-08-02: Используем пришедшие pages для заполнения state в pagesRedux на соотвествующем языке
  const processDataFunction = async res => {
    const pagesRedux = getPagesToRedux({ pages: await res, language: lang });
    dispatch({ type: SET_PAGES_REDUX, payload: pagesRedux });
    return await res;
  };

  // ##### 25-01-09 Komarov
  const url = getUrl('classifier', `classifier=sitepage&language=${lang}`);

  // ##### 25-02-26 Komarov
  uniLog('pages.js', 'axios:src/Redux/actions/pages.js:getPages, url:', url);

  // ##### 25-03-28 Komarov: запрашиваем у Сервера Сайта сохранение данных для запроса с текущими параметрами
  await getSavingDataClient({
    smartUrl: url,
    typeRes: GET_PAGES_RES,
    typeErr: GET_PAGES_ERR,
    dispatch,
    processDataFunction,
  });
};

// ##### 25-04-21 Komarov: TODO: Разделить запросы и сохранение контента в разных разделах Redux state (пока) для разных интерпретаций id в url страниц на сайте
export const getLoadedPage =
  ({
    spid,
    lang,
    deviceType = 'desktop',
    sitepagecity_type_id = 56,
    pageType = 'sitepages',
    // ##### 24-09-16 Komarov
    user_id,
  }) =>
    async dispatch => {
      // ##### 25-04-23 Komarov
      const processDataFunction = async res => {
        return {
          spid,
          lang,
          data: await res,
        };
      };

      // ##### 25-03-07 Komarov
      // dispatch({ type: GET_LOADED_PAGE_REQ });

      const url =
        (pageType === 'sitepagecitycontent' &&
          getUrl(
            'sitepagecitycontent',
            `sitepagecity_id=${spid}&sitepagecity_type_id=${sitepagecity_type_id}&language=${lang}&deviceType=${deviceType}&cityview=1&user_id=${user_id}`
          )) ||
        getUrl(
          'sitepagecontent',
          `id=${spid}&language=${lang}&deviceType=${deviceType}`
        );

      // ##### 25-03-05 Komarov
      uniLog(
        'pages.js',
        'axios:src/Redux/actions/pages.js:getLoadedPage, url:',
        url
      );

      // ##### 25-03-28 Komarov: запрашиваем у Сервера Сайта сохранение данных для запроса с текущими параметрами
      await getSavingDataClient({
        smartUrl: url,
        typeRes: GET_LOADED_PAGE_RES,
        typeErr: GET_LOADED_PAGE_ERR,
        dispatch,
        processDataFunction,
      });

      dispatch({ type: GET_LOADED_PAGE_REQ, payload: { spid, lang } });
    };

// ##### 25-04-07 Komarov
/*export const getPreloadedCityPage =
  (id, deviceType = "desktop", lang = config.defaultLang, user_id) =>
  async (dispatch) => {
    // ##### 25-03-28 Komarov: функция обработки полученного ответа от Смарта (если нужно записать в Redux не просто ответ, а объект с дополнительными полями, в одном из которых будет ответ от Смарта)
    const processDataFunction = async (res) => {
      return {
        id,
        data: await res,
      };
    };

    // ##### 25-03-06 Komarov
    const typeReq = GET_PRELOADED_CITY_PAGE_REQ;
    const typeRes = GET_PRELOADED_CITY_PAGE_RES;
    const typeErr = GET_PRELOADED_CITY_PAGE_ERR;

    const url = getUrl(
      "sitepagecitycontent",
      `sitepagecity_id=${id}&sitepagecity_type_id=56&language=${lang}&deviceType=${deviceType}&cityview=1&user_id=${user_id}`,
    );
    // ##### 25-02-26 Komarov
    uniLog(
      "pagesServer.js",
      "axios:src/Redux/actions/pages.js:getPreloadedPage, url:",
      url,
    );

    // ##### 25-03-28 Komarov: запрашиваем у Сервера Сайта сохранение данных для запроса с текущими параметрами
    await getSavingDataClient({
      smartUrl: url,
      typeRes,
      typeErr,
      dispatch,
      processDataFunction,
    });

    // ##### 25-04-01 Komarov
    dispatch({ type: typeReq, payload: id });
  };*/
